export default __webpack_public_path__ + "static/media/Profile-Picture.270ededf.jpg";